import globals from "@homer.core/globals";
import page from "@homer.core/page";

const url = URL.resolve(location.href);
const id = url.parameter?.newsletter?.unsubscribe?.id;
const hash = url.parameter?.newsletter?.unsubscribe?.hash;

if (id && hash) {
    url.searchParams.delete("newsletter[unsubscribe][id]");
    url.searchParams.delete("newsletter[unsubscribe][hash]");
    page.replace(url.href);

    void globals.demand.request("@apfelkiste/subscription.newsletter").then(([NewsletterSubscription]) => {
        return NewsletterSubscription.unsubscribe({ id, hash });
    });
}
